<template>
    <div style="width: 100px;display: flex;flex-direction: column; justify-content: center;" >
      <a-upload
        v-model:file-list="fileList"
        name="avatar"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        accept="image/*"
        :customRequest="handleUpload"
        :before-upload="beforeUpload"
      >
        <img v-if="imageUrl" :src="imageUrl" alt="avatar" style="border-radius: 4px; max-height: 90px; max-width: 90px;" />
        <div v-else>
          <loading-outlined v-if="loadingImage"></loading-outlined>
          <plus-outlined v-else></plus-outlined>
          <div>点击上传</div>
        </div>
      </a-upload>
      
      <div style="display: flex;flex-direction: row;">
        <a-image  v-if="imageUrl" :src="imageUrl" alt="avatar" style="border-radius: 4px; max-height: 20px; max-width: 40px;" />
        <a-button  v-if="imageUrl" size="small" style="margin-left: 5px;"  danger @click="handleDelete">
          <DeleteOutlined />删除
        </a-button>
      </div>
    </div>
  </template>
  <script>
  
  import { defineComponent, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';
  import OSS from 'ali-oss'
  import {LoadingOutlined, PlusOutlined,DeleteOutlined} from '@ant-design/icons-vue';
  import md5 from 'js-md5';

  export default defineComponent({
    props: {
      file: { // 默认上传
        type: Object,
      },
      maxSize: {
        type: Number,
        default: 500 * 1024,
      },
      imageUrl: {
        type: String,
        default: '',
      }
    },
    components: {
      LoadingOutlined,
      PlusOutlined,
      DeleteOutlined,
    },
    data(){
      return {
        fileList: [],
        loadingImage: false,
        // imageUrl: '',
      }
    },
    mounted() {
      // this.imageUrl = this.modelValue
      if (this.file) {
        this.handleUpload({
          file: this.file,
        })
      }
    },
    methods: {
      handleDelete(){
         this.$emit('update:imageUrl', "")
      },
      // 计算文件MD5
      calculateFileMD5(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const arrayBuffer = e.target.result;
            const md5Value = md5(arrayBuffer);
            resolve(md5Value);
          };
          reader.onerror = (error) => {
            reject(error);
          };
          reader.readAsArrayBuffer(file);
        });
      },
      async handleUpload(file) {
        if (!file.file) {
            message.error("请选择文件")
            return
        }
        this.loadingImage = true
        try {
          // 计算文件MD5
          const filemd5 = await this.calculateFileMD5(file.file);
          // 获取文件名(转为小写)
          const filename =  file.file.name.toLowerCase();
          // /api/aliyun/sts
          const sts = await request.post(`/api/aliyun/sts?image_type=upload&filename=${filename}&filemd5=${filemd5}`, {}, '')
          if (sts.error) {
            message.error(`存储服务授权失败:` + sts.error.message)
            return
          }
          
          const client =  new OSS({
              accessKeyId: sts.data.sts_cert.AccessKeyId,
              accessKeySecret: sts.data.sts_cert.AccessKeySecret,
              stsToken: sts.data.sts_cert.SecurityToken,
              bucket: 'xuantupro',
              region: 'oss-cn-shanghai'
          });
          
          const name = sts.data.filepath;
          var url = "http://statica.xuantu.pro" // 待定
          // 检查文件是否已存在
          if (sts.data.is_exist) {
            // 已存在，使用返回的filepath作为key
            url = `${url}/${name}`
          } else {
            const result = await client.multipartUpload(name, file.file);
            if (result && result.name) {
                url = `${url}/${result.name}`
            } else {
                message.error(`上传失败: ${result.message}`)
                return
            }
          }
          
          // this.imageUrl = url
          this.$emit('update:imageUrl', url)
        } catch (error) {
          message.error(`上传失败: ${error.message}`)
        } finally {
          this.loadingImage = false
        }
      },
      beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        const isLt2M = file.size < this.maxSize;
        if (isJpgOrPng && !isLt2M) {
          message.error(`图片需要小于 ${this.maxSize / 1024}KB`);
          return false
        }
        return true;
      },
    },
  })
  </script>
  <style lang='scss' scoped>
  
  </style>